// チケットが発車時刻を過ぎているかどうか判別する
export const isOverDepartureAt = (boardingDate, departureTime) => {
  // boardingDate: "YYYY-MM-DD", departureTime: "HH:MM"
  const dateNums = boardingDate.split("-");
  const timeNums = departureTime.match(/.{2}/g);
  const departureDateTime = new Date(
    parseInt(dateNums[0]),
    parseInt(dateNums[1]) - 1,
    parseInt(dateNums[2]),
    parseInt(timeNums[0]),
    parseInt(timeNums[1])
  );
  const now = new Date();
  console.log("departureDateTime is ", departureDateTime);
  return now > departureDateTime;
};
